import { ResponsiveImage } from '@sleepstation/components'
import PropTypes from 'prop-types'
import React from 'react'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HeroProductShot = ({ image }) => (
  <ResponsiveImage src={image.url} alt={image.alt} />
)

HeroProductShot.propTypes = {
  image: PropTypes.object.isRequired,
}

export default HeroProductShot
